import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-life",
  "use": "icon-leo-e1-life-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-life\">\r\n<g transform=\"translate(-266.240 -122.880) scale(1.280000)\">\r\n<path d=\"M320 160h384v96l-128 128v64l128 128v160H320V576l128-128v-64L320 256V160zm96 96v48l96 96 96-96v-48H416zm0 512h192v-48l-96-96-96 96v48z\" />\r\n  <path d=\"M480 480h64v64h-64v-64z\" />\r\n  <path d=\"M768 192h128v640H768V192zm48 64v512h32V256h-32z\" />\r\n  <path d=\"M800 704h64v64h-64v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-life.svg
// module id = Zer4
// module chunks = 396